/**
 * Deep-clone a value using the native `structuredClone` algorithm.
 *
 * Preserves:
 * - Primitives, plain objects, arrays, nested structures
 * - Date, RegExp, Map, Set, ArrayBuffer, typed arrays
 *
 * Throws (by design, not by our code) on:
 * - Functions, Symbols, class instances with unserialisable fields, DOM nodes
 *
 * All uses in this project clone plain JSON data (scene.json / image.json /
 * project.json shapes) so none of the failure cases apply. Replaces the older
 * `JSON.parse(JSON.stringify(x))` idiom, which is slower, loses types
 * (forcing non-null assertions post-clone), and silently drops `undefined`.
 */
export function cloneDeep<T>(value: T): T {
	return structuredClone(value);
}
